var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"text-align":"center"},attrs:{"justify":"center"}},[_c('div',{staticClass:"grey--text lighten-5 mt-4"},[_vm._v("Please Wait...")]),_c('v-img',{attrs:{"max-width":"1000","max-height":"1000","src":require("../assets/banner/Under-Maintenance.jpg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }